import { createApp } from 'vue';
import axios from 'axios';

const init = () => {
    const el = document.querySelector('#hero-carousel__storage-counter');

    if (el) {
        const app = createApp({
            delimiters: ['${', '}'],
            data() {
                return {
                    state: 'loading',
                    counter: 0
                }
            },
            mounted() {
                const params = this.getCsrfAwareParams();

                axios.get('/actions/storefirst/unit/get-total-rented', params)
                    .then(response => {
                        this.counter = response.data;
                        this.state = 'ready';
                    }).catch((error) => {
                    this.state = 'error';
                })
            },
            methods: {
                getCsrfAwareParams() {
                    const params = new URLSearchParams();
                    params.append(window.csrfTokenName, window.csrfTokenValue);
                    return params;
                },
            },
        });

        app.mount(el);
    }
}

const storageCounter = async () => {
    init();
};

export default storageCounter;
